var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path 15203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 1.5C4.86456 1.5 1.5 4.86447 1.5 9C1.5 10.3068 1.84827 11.5999 2.5069 12.7396L2.81799 13.2778L2.12146 15.8786L4.72119 15.182L5.25934 15.4929C6.39972 16.1517 7.69336 16.5 9 16.5C13.1354 16.5 16.5 13.1355 16.5 9C16.5 4.86447 13.1354 1.5 9 1.5ZM9 0C13.9702 0 18 4.02974 18 9C18 13.9703 13.9702 18 9 18C7.36267 18 5.83191 17.556 4.50897 16.7917L0 18L1.20831 13.4902C0.444031 12.168 0 10.6372 0 9C0 4.02974 4.02979 0 9 0Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.ec654748d22b1a683e9cd3088d51a8a4.svg";
export { ForwardRef as ReactComponent };